module.exports = __webpack_public_path__ + "static/scale-model-of-360-chicago-in-chicago-illinois-30ec6a76ed64ab935d71f693060244d3.png";